/* d.nuvo product page: gallery, accordion, quantity, variants, Buy now. No dependencies. */
(function () {
  function init() {
    var page = document.querySelector('.product-page');
    if (!page || page.__pj) return;
    page.__pj = true;

    /* ---------- Gallery ---------- */
    var gal = page.querySelector('#productCarousel');
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.carousel-slide'));
      var thumbs = [].slice.call(gal.querySelectorAll('.carousel-thumb'));
      var cur = 0;
      var go = function (n) {
        if (!slides.length) return;
        cur = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('carousel-slide--active', i === cur); });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('carousel-thumb--active', i === cur);
          if (i === cur) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        var th = thumbs[cur];
        if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = gal.querySelector('#galleryPrev'), next = gal.querySelector('#galleryNext');
      if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(cur - 1); else if (e.key === 'ArrowRight') go(cur + 1);
      });
      var main = gal.querySelector('.product-carousel-main'), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var d = x0 - e.changedTouches[0].clientX; x0 = null;
          if (Math.abs(d) > 45) go(d > 0 ? cur + 1 : cur - 1);
        });
      }
      go(0);
    }

    /* ---------- Accordion ---------- */
    page.querySelectorAll('.accordion-trigger').forEach(function (btn) {
      var panel = document.getElementById('accordion-' + btn.getAttribute('data-accordion'));
      if (!panel) return;
      var icon = btn.querySelector('.accordion-icon');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    /* ---------- Quantity ---------- */
    var qty = page.querySelector('.qty-input');
    page.querySelectorAll('.product-qty .qty-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var v = parseInt(qty.value, 10) || 1;
        v = b.getAttribute('data-action') === 'increase' ? v + 1 : Math.max(1, v - 1);
        qty.value = v;
      });
    });

    /* ---------- Variants ---------- */
    var variants = [];
    try { variants = JSON.parse(document.getElementById('productVariants').textContent) || []; } catch (e) {}
    var groups = [].slice.call(page.querySelectorAll('.variant-group'));
    var idInput = document.getElementById('variantId');
    var buy = document.getElementById('buyNow');
    var atc = document.getElementById('mainAddToCart');
    var priceEl = page.querySelector('.product-price');
    var cmpEl = page.querySelector('.product-compare-price');
    var cur$ = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD';
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-SG', { style: 'currency', currency: cur$, minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
    catch (e) { fmt = { format: function (n) { return cur$ + ' ' + Math.round(n); } }; }
    var money = function (c) { return fmt.format(c / 100); };
    var picked = groups.map(function (g) {
      var first = g.querySelector('.variant-option');
      return first ? first.getAttribute('data-value') : null;
    });
    var mark = function () {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.variant-option').forEach(function (o) {
          var on = o.getAttribute('data-value') === picked[gi];
          o.classList.toggle('is-selected', on); o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    };
    var apply = function () {
      var v = variants.find(function (x) {
        return picked.every(function (val, i) { return x['option' + (i + 1)] === val; });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (buy) buy.setAttribute('data-variant', v.id);
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) cmpEl.textContent = v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to Routine — ' + money(v.price) : 'Sold Out';
      }
      if (buy) buy.disabled = !v.available;
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    };
    groups.forEach(function (g, gi) {
      g.querySelectorAll('.variant-option').forEach(function (o) {
        o.addEventListener('click', function () { picked[gi] = o.getAttribute('data-value'); mark(); apply(); });
      });
    });
    if (groups.length) mark();

    /* ---------- Buy now: add, then go straight to checkout ---------- */
    if (buy) buy.addEventListener('click', function () {
      var label = buy.textContent; buy.disabled = true; buy.textContent = 'One moment…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(buy.getAttribute('data-variant'), 10), quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1 })
      }).then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
        .catch(function () { buy.disabled = false; buy.textContent = label; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
